import React from 'react';

import { MdModeEdit, MdDelete, MdCheck } from 'react-icons/md';

import history from '~/services/history';

const columnQuadril = () => {
  const editarLinha = (id, data) => {
    history.push({
      pathname: `/formulario-linhas-de-cuidado/${data.linhaDeCuidadoValue}`,
      state: {
        periodo: data.periodoSelecionado,
        indicador: data.linhaDeCuidadoValue,
        indicadorNome: data.linhaDeCuidado,
        idRecord: Number(id),
        id: Number(id),
      },
    });
  };

  const deletarLinha = (id, data) => {
    history.push({
      pathname: `/linha-de-cuidado/${data.linhaDeCuidadoValue}`,
      state: {
        periodo: data.periodoSelecionado,
        indicador: data.linhaDeCuidadoValue,
        indicadorNome: data.linhaDeCuidado,
        deleteLinha: Number(id),
      },
    });
  };

  return [
    {
      title: 'Número do registro',
      dataIndex: 'num_registro_quadril',
      key: 'num_registro_quadril',
      width: 170,
      sorter: (a, b) => a.num_registro_quadril - b.num_registro_quadril,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Identificador do paciente',
      dataIndex: 'identificadordoPaciente',
      key: 'identificadordoPaciente',
      width: 210,
    },

    {
      title: 'Completo',
      key: 'completo',
      dataIndex: 'completo',
      width: 120,
      sorter: (a, b) => a.completo - b.completo,
      sortDirections: ['descend', 'ascend'],
      render: (id, data) => {
        return (
          <div>{data.completo && <MdCheck size={20} color="#74a50a" />}</div>
        );
      },
    },
    {
      title: '',
      key: 'id',
      dataIndex: 'id',
      width: 210,
      render: (id, data) => {
        return (
          <div className="botoesGrid">
            <button type="button" onClick={() => editarLinha(id, data)}>
              <MdModeEdit size={18} />
              Editar
            </button>
            <button
              type="button"
              className="btn-remove"
              onClick={() => deletarLinha(id, data)}
            >
              <MdDelete size={18} />
              Excluir
            </button>
          </div>
        );
      },
    },

    {
      title: 'Sexo',
      dataIndex: 'sexo_quadril_descritivo',
      key: 'sexo_quadril',
      width: 100,
    },

    {
      title: 'Data de nascimento',
      dataIndex: 'dn_quadril',
      key: 'dn_quadril',
      width: 110,
    },

    {
      title: 'Convênio do paciente',
      dataIndex: 'convenio_quadril_descritivo',
      key: 'convenio_quadril',
      width: 130,
    },
    {
      title: 'Infarto agudo do miocárdio',
      dataIndex: 'iam_quadril_descritivo',
      key: 'iam_quadril',
      width: 120,
    },
    {
      title: 'Insuficiência cardíaca',
      dataIndex: 'ic_quadril_descritivo',
      key: 'ic_quadril',
      width: 110,
    },
    {
      title: 'Doença vascular periférica',
      dataIndex: 'dvp_quadril_descritivo',
      key: 'dvp_quadril',
      width: 100,
    },
    {
      title: 'AVC ou AIT',
      dataIndex: 'avc_ait_quadril_descritivo',
      key: 'avc_ait_quadril',
      width: 100,
    },
    {
      title: 'Demência',
      dataIndex: 'demencia_quadril_descritivo',
      key: 'demencia_quadril',
      width: 150,
    },
    {
      title: 'DPOC',
      dataIndex: 'dpoc_quadril_descritivo',
      key: 'dpoc_quadril',
      width: 100,
    },
    {
      title: 'Doença do tecido conjuntivo',
      dataIndex: 'dtc_quadril_descritivo',
      key: 'dtc_quadril',
      width: 120,
    },
    {
      title: 'Doença hepática',
      dataIndex: 'hepatica_quadril_descritivo',
      key: 'hepatica_quadril',
      width: 100,
    },
    {
      title: 'Diabetes mellitus',
      dataIndex: 'dm_quadril_descritivo',
      key: 'dm_quadril',
      width: 100,
    },
    {
      title: 'Doença renal crônica',
      dataIndex: 'drc_quadril_descritivo',
      key: 'drc_quadril',
      width: 120,
    },
    {
      title: 'Tumor sólido',
      dataIndex: 'tumor_quadril_descritivo',
      key: 'tumor_quadril',
      width: 100,
    },
    {
      title: 'Leucemia',
      dataIndex: 'leucemia_quadril_descritivo',
      key: 'leucemia_quadril',
      width: 100,
    },
    {
      title: 'Linfoma',
      dataIndex: 'linfoma_quadril_descritivo',
      key: 'linfoma_quadril',
      width: 100,
    },
    {
      title: 'AIDS',
      dataIndex: 'aids_quadril_descritivo',
      key: 'aids_quadril',
      width: 100,
    },
    {
      title: 'Pontuação no escore de HOOS-PS no pré-operatório',
      dataIndex: 'hoos_quadril',
      key: 'hoos_quadril',
      width: 150,
    },
    {
      title:
        'O paciente apresentava limitação total para caminhada ou outras atividades que requeiram o uso dos membros inferiores',
      dataIndex: 'dependencia_quadril_descritivo',
      key: 'dependencia_quadril',
      width: 210,
    },
    {
      title: 'Pontuação no MEEM pré-operatório',
      dataIndex: 'meem_quadril',
      key: 'meem_quadril',
      width: 120,
    },

    {
      title: 'Escolaridade em anos de estudo',
      dataIndex: 'escolaridade_quadril',
      key: 'escolaridade_quadril',
      width: 100,
    },

    {
      title:
        'Caráter da internação hospitalar para realização da artroplastia total de quadril',
      dataIndex: 'internacao_quadril_descritivo',
      key: 'internacao_quadril',
      width: 190,
    },

    {
      title: 'Paciente politraumatizado',
      dataIndex: 'politrauma_quadril_descritivo',
      key: 'politrauma_quadril',
      width: 140,
    },

    {
      title: 'Data da chegada do paciente no hospital',
      dataIndex: 'entrada_data_quadril',
      key: 'entrada_data_quadril',
      width: 120,
    },

    {
      title: 'Hora da chegada do paciente no hospital',
      dataIndex: 'entrada_hora_quadril',
      key: 'entrada_hora_quadril',
      width: 120,
    },

    {
      title: 'Data da admissão no centro cirúrgico',
      dataIndex: 'admissao_data_quadril',
      key: 'admissao_data_quadril',
      width: 120,
    },

    {
      title: 'Hora da admissão no centro cirúrgico',
      dataIndex: 'admissao_hora_quadril',
      key: 'admissao_hora_quadril',
      width: 120,
    },
    {
      title: 'Data da administração de antibioticoterapia profilática',
      dataIndex: 'antibiotico_data_quadril',
      key: 'antibiotico_data_quadril',
      width: 140,
    },
    {
      title: 'Hora da administração de antibioticoterapia profilática',
      dataIndex: 'antibiotico_hora_quadril',
      key: 'antibiotico_hora_quadril',
      width: 140,
    },
    {
      title: 'Data da incisão cirúrgica',
      dataIndex: 'incisao_data_quadril',
      key: 'incisao_data_quadril',
      width: 110,
    },
    {
      title: 'Hora da incisão cirúrgica',
      dataIndex: 'incisao_hora_quadril',
      key: 'incisao_hora_quadril',
      width: 110,
    },
    {
      title:
        'Paciente recebeu profilaxia para tromboembolismo venoso durante a internação',
      dataIndex: 'profilaxia_tv_quadril_descritivo',
      key: 'profilaxia_tv_quadril',
      width: 180,
    },
    {
      title: 'Paciente em uso de anticoagulação plena durante a internação',
      dataIndex: 'anticoagulacao_quadril_descritivo',
      key: 'anticoagulacao_quadril',
      width: 180,
    },
    {
      title: 'Paciente foi submetido à avaliação sistemática da dor',
      dataIndex: 'dor_quadril_descritivo',
      key: 'dor_quadril',
      width: 130,
    },
    {
      title:
        'Data do primeiro momento em que o paciente ficou sentado após a cirurgia',
      dataIndex: 'sentar_data_quadril',
      key: 'sentar_data_quadril',
      width: 130,
    },
    {
      title:
        'Hora do primeiro momento em que o paciente ficou sentado após a cirurgia',
      dataIndex: 'sentar_hora_quadril',
      key: 'sentar_hora_quadril',
      width: 140,
    },
    {
      title:
        'Data do primeiro momento em que o paciente deambulou após a cirurgia',
      dataIndex: 'deambular_data_quadril',
      key: 'deambular_data_quadril',
      width: 140,
    },
    {
      title:
        'Hora do primeiro momento em que o paciente deambulou após a cirurgia',
      dataIndex: 'deambular_hora_quadril',
      key: 'deambular_hora_quadril',
      width: 170,
    },

    {
      title: 'Paciente teve diagnóstico de COVID-19 durante a internação',
      dataIndex: 'covid_quadril',
      key: 'covid_quadril',
      width: 210,
    }, //

    {
      title: 'Motivo da saída hospitalar',
      dataIndex: 'saida_motivo_quadril_descritivo',
      key: 'saida_motivo_quadril',
      width: 100,
    },
    {
      title: 'Data da saída',
      dataIndex: 'saida_data_quadril',
      key: 'saida_data_quadril',
      width: 120,
    },
    {
      title: 'Hora da saída',
      dataIndex: 'saida_hora_quadril',
      key: 'saida_hora_quadril',
      width: 100,
    },
    {
      title: 'Paciente em medidas de conforto ou cuidados paliativos',
      dataIndex: 'paliativo_quadril_descritivo',
      key: 'paliativo_quadril',
      width: 150,
    },

    {
      title: 'Paciente reinternou em até 30 dias após a saída da instituição',
      dataIndex: 'reinternacao_quadril_descritivo',
      key: 'reinternacao_quadril',
      width: 150,
    },

    {
      title: 'Reinternação foi por motivo relacionado à ATQ',
      dataIndex: 'reinternacao_motivo_quadril_descritivo',
      key: 'reinternacao_motivo_quadril',
      width: 140,
    },

    {
      title:
        'Paciente apresentou infecção de sítio cirúrgico em até 3 meses do procedimento',
      dataIndex: 'infeccao_quadril_descritivo',
      key: 'infeccao_quadril',
      width: 170,
    },

    {
      title: 'Data do diagnóstico de infecção',
      dataIndex: 'infeccao_data_quadril',
      key: 'infeccao_data_quadril',
      width: 120,
    },

    {
      title: 'Paciente foi a óbito no período de até 1 ano após a alta',
      dataIndex: 'obito_seg_quadril_descritivo',
      key: 'obito_seg_quadril',
      width: 130,
    },
  ];
};

export default columnQuadril;
